// @ts-nocheck
// TODO: tighten types after migration
/**
 * Cart utility functions to handle user-isolated storage
 */

import { getAuthUser } from '../utils/auth';

const CART_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

const getCartKey = () => {
    try {
        const userData = getAuthUser();
        // Check both _id (typical for MongoDB) and id
        const userId = userData ? (userData._id || userData.id) : 'guest';
        return `cart_${userId}`;
    } catch (error) {
        return 'cart_guest';
    }
};

const getCouponsKey = () => {
    try {
        const userData = getAuthUser();
        const userId = userData ? (userData._id || userData.id) : 'guest';
        return `appliedCoupons_${userId}`;
    } catch (error) {
        return 'appliedCoupons_guest';
    }
};

const isGuestUser = () => {
    try {
        const userData = getAuthUser();
        return !userData;
    } catch (error) {
        return true;
    }
};

export const getCartFromStorage = () => {
    try {
        // Check expiration for guest users
        if (isGuestUser()) {
            const lastActivity = localStorage.getItem('cart_last_activity');
            if (lastActivity) {
                const now = Date.now();
                if (now - parseInt(lastActivity, 10) > CART_TIMEOUT_MS) {
                    console.log('Guest cart expired due to inactivity');
                    clearCart();
                    return [];
                } else {
                    // Update activity if not expired (keep session alive)
                    localStorage.setItem('cart_last_activity', now.toString());
                }
            } else {
                // If cart exists but no timestamp, start tracking now ? 
                // Or if accessing empty cart, it doesn't matter.
                // We'll set it when saving or if cart is not empty.
                const key = getCartKey();
                const cart = localStorage.getItem(key);
                if (cart && JSON.parse(cart).length > 0) {
                     localStorage.setItem('cart_last_activity', Date.now().toString());
                }
            }
        }

        const key = getCartKey();
        const cart = localStorage.getItem(key);
        return cart ? JSON.parse(cart) : [];
    } catch (error) {
        console.error('Error reading cart from storage:', error);
        return [];
    }
};

export const saveCartToStorage = (cart) => {
    try {
        const key = getCartKey();
        localStorage.setItem(key, JSON.stringify(cart));
        
        // Update activity timestamp for guest users
        if (isGuestUser()) {
            localStorage.setItem('cart_last_activity', Date.now().toString());
        }

        // Also dispatch a storage event for other components to update
        window.dispatchEvent(new Event('storage'));
    } catch (error) {
        console.error('Error saving cart to storage:', error);
    }
};

export const getCouponsFromStorage = () => {
    try {
        const key = getCouponsKey();
        const coupons = localStorage.getItem(key);
        return coupons ? JSON.parse(coupons) : [];
    } catch (error) {
        console.error('Error reading coupons from storage:', error);
        return [];
    }
};

export const saveCouponsToStorage = (coupons) => {
    try {
        const key = getCouponsKey();
        localStorage.setItem(key, JSON.stringify(coupons));
        window.dispatchEvent(new Event('storage'));
    } catch (error) {
        console.error('Error saving coupons to storage:', error);
    }
};

export const clearCart = () => {
    try {
        localStorage.removeItem(getCartKey());
        localStorage.removeItem(getCouponsKey());
        if (isGuestUser()) {
            localStorage.removeItem('cart_last_activity');
        }
        window.dispatchEvent(new Event('storage'));
    } catch (error) {
        console.error('Error clearing cart:', error);
    }
    return [];
};

// Also export keys for direct access if needed
export const STORAGE_KEYS = {
    getCartKey,
    getCouponsKey
};

